import axios from 'axios'
import sagawa from '@/sagawa.js'

const getStorageInfo = function() {
  try {
    window.console.log('key', process.env.VUE_APP_STORAGE_KEY)
    let data = JSON.parse(localStorage.getItem(process.env.VUE_APP_STORAGE_KEY) || '{}')
    window.console.log('storage data', data)
    return data
  } catch(e) {
    window.console.warn(e)
    return {}
  }
}
const setStorageInfo = function(key, value) {
  try {
    var info = getStorageInfo()
    info[key] = value
    const data = JSON.stringify(info)
    localStorage.setItem(process.env.VUE_APP_STORAGE_KEY, data)
  } catch(e) {
    window.console.warn(e)
  }
}
const zen2han = (str) => {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
}
/* const escapeTag = (val) => {
  return val.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/\r?\n/g, '<br>')
}; */

export default {
  namespaced: true,
  state: {
    token: "",
    submitResult: {},
    zipCode: "",
    ken: "",
    address: "",
    schoolFounder: "",
    schoolCode: "",
    useOtherSchoolName: false,
    otherSchoolName: "",
    teacherNameFamily: "",
    teacherNameFirst: "",
    teacherKanaFamily: "",
    teacherKanaFirst: "",
    subject: "",
    tel1: "",
    tel2: "",
    tel3: "",
    mail: "",
    receipt: "",
    entrant: [{
      key: 0,
      nameFamily: '',
      nameFirst: '',
      kanaFamily: '',
      kanaFirst: '',
      subject: '',
      grade: '',
      division: ''
    }],
    payment: "bill"
  },
  getters: {
    submitResult(state) {
      return state.submitResult
    },
    dispZipCode(state) {
      const zip = zen2han(String(state.zipCode))
      const zip1 = zip.match(/^\d{3}/)[0]
      const zip2 = zip.match(/\d{4}$/)[0]
      return zip1 + '-' + zip2
    },
    schoolCode(state) { return state.schoolCode },
    schoolName(state, _getters, _rootState, rootGetters) {
      if (state.useOtherSchoolName) return state.otherSchoolName;
      let sc = state.schoolCode;
      if (sc == "") return "";
      let si = rootGetters['schoolList'].find(i => i.code == sc) || {}
      window.console.log('school', si)
      return si.name || ""
    },
    kenName(state, _getters, _rootState, rootGetters) {
      if (state.ken == '') return ''
      let ken = rootGetters['kenList'].find(item => item.code == state.ken) || {}
      return ken.name || ""
    },
    address(state) {
      return state.address
    },
    schoolFounderName(state, _getters, _rootState, rootGetters) {
      if (state.schoolFounder == '') return ''
      let founder = rootGetters['schoolFounderList'].find(item => item.code == state.schoolFounder) || {}
      return founder.name || ""
    },
    teacherName(state) {
      return [state.teacherNameFamily, state.teacherNameFirst].join(" ")
    },
    teacherKana(state) {
      return [state.teacherKanaFamily, state.teacherKanaFirst].join(" ")
    },
    tel(state) {
      return zen2han([state.tel1, state.tel2, state.tel3].join("-"))
    },
    mail(state) {
      return state.mail
    },
    payment(state) { return state.payment },
    dispPayment(state, _getters, _rootState, rootGetters) {
      if (state.payment == '') return ''
      return rootGetters['paymentList'].find((payment) => {
        return payment.code == state.payment
      }).name
    },
    paymentId(state, _getters, _rootState, rootGetters) {
      if (state.payment == '') return ''
      return rootGetters['paymentList'].find((payment) => {
        return payment.code == state.payment
      }).id
    },
    subject(state) {return state.subject },
    receipt(state) { return state.receipt },
    dispReceipt(state) {
      return state.receipt
    },
    submitEntrant(state) {
      return state.entrant //.filter(e => e.part != 0) // 不参加を除外
    },
    entrantCount(state, getters) {
      return getters.submitEntrant.length;
    },
    entrantTable(state, getters) {
      return getters.submitEntrant.map((e, i) => {
        const name = [e.nameFamily, e.nameFirst].join(' ')
        const kana = [e.kanaFamily, e.kanaFirst].join(' ')
        // 分掌 区切り文字エスケープ
        // SQL処理は全角半角区別しないため，全角にエスケープしてもエラー→空白にしておく
        const division = e.division.replace(/[,，|｜]/g, ' ')
        window.console.log('division', division)
        return [i+1, name, kana, e.subject, e.grade, division].join(",")
      }).join("|")
    },
    dispEntrant(state, getters) {
      return getters.submitEntrant.map(e => {
        return {
          name: [e.nameFamily, e.nameFirst].join(' '),
          kana: [e.kanaFamily, e.kanaFirst].join(' ')
        };
      });
    },
    charge(_state, getters) {
      const count = getters['entrantCount']
      return 1000 * count
    },
    dispCharge(_state, getters) {
      return getters['charge'].toLocaleString()
    },
    isRitou(state) {
      if (state.ken == '47') return true; // 沖縄は無条件に離島扱い
      return sagawa.isRitouSchool(state.schoolCode) // 中継料対象校判定
    },
    submitParams(state, getters, rootState) {
      let params = new URLSearchParams()
      params.append("token", state.token)
      params.append("postal_code", getters.dispZipCode)
      params.append("ken", state.ken)
      params.append("address", state.address)
      params.append("school_founder", state.schoolFounder)
      params.append("school_code", state.schoolCode)
      params.append("school_name", getters.schoolName)
      params.append("subject_code", getters.subject)
      params.append("teacher_name", getters.teacherName)
      params.append("teacher_kana", getters.teacherKana)
      params.append("receipt_name", getters.receipt)
      params.append("tel", getters.tel)
      params.append("mail", getters.mail)
      params.append("force_entry", rootState.forceEntry)
      return params
    }
  },
  mutations: {
    clearSchoolCode(state) {
      state.schoolCode = ""
    },
    clearAddress(state) {
      state.address = ""
    },
    setAddressFromZipCode(state, payload) {
      state.ken = ("0" + payload.region_id).slice(-2)
      state.address = payload.locality + payload.street + payload.extended
    },
    setAddressFromSchoolCode(state, payload) {
      const params = {
        code: payload.code
      }
      axios.get(process.env.VUE_APP_BASE_URL + "api/optscaddr.asp", { params })
      .then(res => {
        console.log(res.data)
        const info = res.data[0]
        if (!info) return
        state.zipCode = info.pn.replace(/\D/g, '')
        state.address = info.addr.replace(/　/g, '')
      })
      .catch(e => {
        window.console.warn('error', e)
      })
    },
    setInitialEntryData(state, payload) {
      window.console.log('setInitialEntryData')
      state.mail = payload.mail
      setStorageInfo("mail", payload.mail)
      state.token = payload.token
      setStorageInfo("token", payload.token)
    },
    clearInitialEntryToken(state) {
      state.token = ''
      setStorageInfo("token", "")
    },
    setSubmitResult(state, payload) {
      state.submitResult = payload.data
    },
    loadStorageEntry(state) {
      window.console.log('loadStorageEntry')
      let info = getStorageInfo()
      state.mail = info.mail || ""
      state.token = info.token || ""
    },
    setEvent(state, payload) {
      state.event = payload
      setStorageInfo("event", payload)
    },
    setFirstReceipt(state, payload) {
      state.receipt = payload.receipt
    },
    setFirstEntrant(state, payload) {
      for (let key in payload) {
        state.entrant[0][key] = payload[key]
      }
    },
    appendEntrant(state, payload) {
      state.entrant.push(payload)
    },
    removeEntrant(state, payload) {
      state.entrant = state.entrant.filter(ent => ent.key != payload.key)
    }
  },
  actions: {
    clearSchoolCode({ commit }) {
      commit("clearSchoolCode")
    },
    clearAddress({ commit }) {
      commit("clearAddress")
    },
    setAddressFromZipCode({ commit }, payload) {
      commit("setAddressFromZipCode", payload)
    },
    setAddressFromSchoolCode({ commit }, payload) {
      commit("setAddressFromSchoolCode", payload)
    },
    setInitialEntryData({ commit }, payload) {
      commit("setInitialEntryData", payload)
    },
    clearInitialEntryToken({ commit }) {
      commit("clearInitialEntryToken")
    },
    setSubmitResult({ commit }, payload) {
      commit("setSubmitResult", payload)
    },
    setEvent({ commit }, payload) {
      commit("setEvent", payload)
    },
    setFirstReceipt({ commit }, payload) {
      commit("setFirstReceipt", payload)
    },
    setFirstEntrant({ commit }, payload) {
      commit("setFirstEntrant", payload)
    },
    appendEntrant({ commit }, payload) {
      commit("appendEntrant", payload)
    },
    removeEntrant({ commit }, payload) {
      commit("removeEntrant", payload)
    }
  }
}